import styled from '../../../../../node_modules/@mui/material/styles/styled.mjs';

const PaddingLeft = styled('div')({
    paddingLeft: '34px'
});

export { PaddingLeft };
//# sourceMappingURL=PaddingLeft.mjs.map
